import React from "react";
import { DEFAULT_TABLE_PAGE_SIZE, TABLE_HEADER_HEIGHT, TABLE_ROW_HEIGHT } from "../../utils/constants";
import { DataGrid, useGridSlotComponentProps } from "@material-ui/data-grid";
import { Pagination, PaginationItem } from "@material-ui/lab";
import { makeStyles, Typography } from "@material-ui/core";
import { useIntl } from "react-intl";

const useStyles = makeStyles((theme) => ({
  gridContainer: {
    padding: theme.spacing(2),
  },
  table: {
    height: "28rem",
    boxShadow: "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
  },
}));

const CustomNoRowsOverlay = () => {
  const intl = useIntl();
  return (
    <Typography className="MuiDataGrid-overlay">{intl.formatMessage({ id: "custom.no_results_found" })}</Typography>
  );
};

const PaginationComponent = () => {
  const { state, apiRef } = useGridSlotComponentProps();
  return (
    <Pagination
      color="primary"
      shape="rounded"
      page={state.pagination.page + 1}
      count={state.pagination.pageCount}
      renderItem={(props2) => <PaginationItem {...props2} disableRipple />}
      onChange={(event, value) => apiRef.current.setPage(value - 1)}
    />
  );
};

const CustomDataGrid = ({ rows, columns, getRowId }) => {
  const classes = useStyles();
  return (
    <div className={classes.gridContainer}>
      <DataGrid
        components={{
          Pagination: PaginationComponent,
          NoRowsOverlay: CustomNoRowsOverlay,
        }}
        columns={columns}
        rows={rows}
        getRowId={getRowId}
        className={classes.table}
        disableColumnMenu
        disableSelectionOnClick
        columnBuffer={0}
        density={20}
        headerHeight={TABLE_HEADER_HEIGHT}
        logger={false}
        rowHeight={TABLE_ROW_HEIGHT}
        sortingOrder={[]}
        localeText={""}
        pageSize={DEFAULT_TABLE_PAGE_SIZE}
      />
    </div>
  );
};

export default CustomDataGrid;
